import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "src/components/atoms/Calendar/styles.module.css";
import { useIntl } from "react-intl";
import { msg } from "src/i18n/Msg";
import { DictionaryKey } from "src/types/language";
import { dateFnsLocale } from "src/utils/dateLocale";
import "./stylesCalendar.css";

type Props = {
  onChange: (date: Date | null) => void;
  value: Date | null;
};

// Порядок соответствует Date#getMonth() (0 = январь).
const MONTH_KEYS: DictionaryKey[] = [
  "components.atoms.Calendar.month.1",
  "components.atoms.Calendar.month.2",
  "components.atoms.Calendar.month.3",
  "components.atoms.Calendar.month.4",
  "components.atoms.Calendar.month.5",
  "components.atoms.Calendar.month.6",
  "components.atoms.Calendar.month.7",
  "components.atoms.Calendar.month.8",
  "components.atoms.Calendar.month.9",
  "components.atoms.Calendar.month.10",
  "components.atoms.Calendar.month.11",
  "components.atoms.Calendar.month.12",
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 11 }, (_, i) => currentYear + i);

export const Calendar: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();
  const handleChange = (date: Date | null) => {
    onChange(date);
  };

  return (
    <div className={styles.calendar}>
      <DatePicker
        selected={value}
        inline
        locale={dateFnsLocale}
        onChange={(date) => handleChange(date)}
        minDate={new Date()}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          changeYear,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className={styles.customHeader}>
            <button
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
              className={styles.navBtn}
              type="button"
            >
              ‹
            </button>
            <div className={styles.headerCenter}>
              <span className={styles.monthName}>
                {msg(intl, { id: MONTH_KEYS[date.getMonth()] })}
              </span>
              <select
                className={styles.yearSelect}
                value={date.getFullYear()}
                onChange={(e) => changeYear(Number(e.target.value))}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <button
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
              className={styles.navBtn}
              type="button"
            >
              ›
            </button>
          </div>
        )}
      />
    </div>
  );
};
